import * as React from 'react';
import { SAnchoredData, TInferSchemaType } from '@/constants/schemas';
import { DEFAULT_PAGE_SIZE } from '@/constants/config';

const paramsInitialState = {
  page: 1,
  nextId: undefined,
  prevId: undefined,
  pageSize: DEFAULT_PAGE_SIZE,
};

const useAnchoredPaginationParams = <T extends Record<string, any>>(
  data: TInferSchemaType<ReturnType<typeof SAnchoredData>>,
  extraFilters: T = {} as T,
): {
  params: {
    page: number;
    nextId?: string;
    prevId?: string;
    pageSize: number;
  } & T;
  onClickPrev: () => void;
  onClickNext: () => void;
  setParams: React.Dispatch<
    React.SetStateAction<{
      page: number;
      nextId?: string;
      prevId?: string;
      pageSize?: number;
    } & T>
  >;
} => {
  const [params, setParams] = React.useState(paramsInitialState);
  const { prevId, nextId, hasNext } = data || {};

  // console.log('%c~LOG~', 'color: yellow; font-size: 16px;', data);

  const onClickNext = nextId
    ? () => {
        setParams((prev) => ({
          ...prev,
          page: prev.page + 1,
          nextId,
          prevId: undefined,
        }));
      }
    : undefined;

  const onClickPrev = prevId
    ? () => {
        setParams((prev) => ({
          ...prev,
          page: prev.page - 1,
          prevId,
          nextId: undefined,
        }));
      }
    : undefined;
    
  return {
    params: {
      ...params,
      ...extraFilters,
    },
    onClickPrev,
    onClickNext,
    setParams: setParams as any,
  };
};

export default useAnchoredPaginationParams;
